/* prettier-ignore-start */

/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file is auto-generated by TanStack Router

import { createFileRoute } from '@tanstack/react-router'

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as MoviesIndexImport } from './routes/movies/index'
import { Route as AboutIndexImport } from './routes/about/index'
import { Route as MoviesMovieIdIndexImport } from './routes/movies/$movieId/index'

// Create Virtual Routes

const IndexLazyImport = createFileRoute('/')()

// Create/Update Routes

const IndexLazyRoute = IndexLazyImport.update({
  path: '/',
  getParentRoute: () => rootRoute,
} as any).lazy(() => import('./routes/index.lazy').then((d) => d.Route))

const MoviesIndexRoute = MoviesIndexImport.update({
  path: '/movies/',
  getParentRoute: () => rootRoute,
} as any).lazy(() => import('./routes/movies/index.lazy').then((d) => d.Route))

const AboutIndexRoute = AboutIndexImport.update({
  path: '/about/',
  getParentRoute: () => rootRoute,
} as any).lazy(() => import('./routes/about/index.lazy').then((d) => d.Route))

const MoviesMovieIdIndexRoute = MoviesMovieIdIndexImport.update({
  path: '/movies/$movieId/',
  getParentRoute: () => rootRoute,
} as any).lazy(() =>
  import('./routes/movies/$movieId/index.lazy').then((d) => d.Route),
)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexLazyImport
      parentRoute: typeof rootRoute
    }
    '/about/': {
      id: '/about/'
      path: '/about'
      fullPath: '/about'
      preLoaderRoute: typeof AboutIndexImport
      parentRoute: typeof rootRoute
    }
    '/movies/': {
      id: '/movies/'
      path: '/movies'
      fullPath: '/movies'
      preLoaderRoute: typeof MoviesIndexImport
      parentRoute: typeof rootRoute
    }
    '/movies/$movieId/': {
      id: '/movies/$movieId/'
      path: '/movies/$movieId'
      fullPath: '/movies/$movieId'
      preLoaderRoute: typeof MoviesMovieIdIndexImport
      parentRoute: typeof rootRoute
    }
  }
}

// Create and export the route tree

export const routeTree = rootRoute.addChildren({
  IndexLazyRoute,
  AboutIndexRoute,
  MoviesIndexRoute,
  MoviesMovieIdIndexRoute,
})

/* prettier-ignore-end */

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/",
        "/about/",
        "/movies/",
        "/movies/$movieId/"
      ]
    },
    "/": {
      "filePath": "index.lazy.tsx"
    },
    "/about/": {
      "filePath": "about/index.tsx"
    },
    "/movies/": {
      "filePath": "movies/index.tsx"
    },
    "/movies/$movieId/": {
      "filePath": "movies/$movieId/index.tsx"
    }
  }
}
ROUTE_MANIFEST_END */
